import React from 'react';
import { useTranslation } from 'react-i18next';
import { changeLocale, currentLocale } from './index';
import type { UiLocale } from '../lib/localePrefs';
import './language-switcher.css';

export function LanguageSwitcher({
  compact = false,
}: {
  compact?: boolean;
}) {
  const { t } = useTranslation('common');
  const locale = currentLocale();

  const set = (next: UiLocale) => {
    if (next === locale) return;
    void changeLocale(next);
  };

  return (
    <div
      className={`lang-switcher${compact ? ' is-compact' : ''}`}
      role="group"
      aria-label={t('language')}
    >
      <button
        type="button"
        className={`lang-switcher-btn${locale === 'en' ? ' is-active' : ''}`}
        aria-pressed={locale === 'en'}
        onClick={() => set('en')}
      >
        EN
      </button>
      <button
        type="button"
        className={`lang-switcher-btn${locale === 'de' ? ' is-active' : ''}`}
        aria-pressed={locale === 'de'}
        onClick={() => set('de')}
      >
        DE
      </button>
    </div>
  );
}
